import { useDispatch, useSelector } from 'react-redux';
import { toggleDarkMode } from '@/actions';
import { Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

export function ThemeToggle() {
  const dispatch = useDispatch();
  const darkMode = useSelector((state: any) => state.ui?.darkMode);

  return (
    <div className="flex items-center space-x-2">
      <Sun className="h-4 w-4 text-gray-600 dark:text-gray-400" />
      <Switch
        checked={darkMode}
        onCheckedChange={() => dispatch(toggleDarkMode())}
        aria-label="Toggle dark mode"
      />
      <Moon className="h-4 w-4 text-gray-600 dark:text-gray-400" />
    </div>
  );
}

